export const FETCH_READING_LOG_VALUES = "FETCH_READING_LOG_VALUES";
export const SAVE_READING_LOG = "SAVE_READING_LOG";
